import { money } from "./format";

// A returning, signed-in visitor's previously-run home values (SUR-1866). Shown
// under the address search so they can re-open a report (re-polls the ez
// user_home) or delete one. Renders nothing when there are none.
export default function SavedHomeValues({ saved, onOpen, onDelete }) {
  if (!saved || saved.length === 0) return null;

  return (
    <div style={{ marginTop: "1.5rem", textAlign: "left" }}>
      <h3 style={{ margin: "0 0 0.6rem", fontSize: "0.95rem", color: "var(--ss-connect-primary)" }}>
        Your home values
      </h3>
      <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: "0.5rem" }}>
        {saved.map((hv) => (
          <li
            key={hv.id}
            className="ss-c-card"
            style={{ margin: 0, padding: "0.6rem 0.75rem", display: "flex", alignItems: "center", gap: "0.5rem" }}
          >
            <button
              type="button"
              onClick={() => onOpen(hv)}
              style={{
                flex: 1,
                textAlign: "left",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                padding: 0,
              }}
            >
              <div style={{ fontWeight: 600, color: "var(--ss-connect-text)" }}>{hv.address || "Saved home value"}</div>
              {hv.estimate ? (
                <div style={{ fontSize: "0.9rem", color: "var(--ss-connect-primary)", fontWeight: 700 }}>
                  {money(hv.estimate)}
                </div>
              ) : null}
            </button>
            <button
              type="button"
              aria-label="Delete saved home value"
              title="Delete"
              onClick={() => onDelete(hv.id)}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                color: "var(--ss-connect-text-muted)",
                fontSize: "1.1rem",
                lineHeight: 1,
                padding: "0.2rem 0.4rem",
              }}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
